import { Injectable } from '@angular/core';

import { ApiModel } from './api.model';

@Injectable()
export class FileModel {
    constructor(private apiModel: ApiModel) {}

    deleteFile(fileId: string): Promise<any> {
        return this.apiModel.makeHttpRequest({
            method: 'DELETE',
            url: `${this.apiModel.getFilesEndpoint()}/${fileId}`
        });
    }

    updateFile(fileId: string, data: any): Promise<any> {
        return this.apiModel.makeHttpRequest({
            method: 'PUT',
            url: `${this.apiModel.getFilesEndpoint()}/${fileId}`,
            body: data
        });
    }
}
